import {user} from "@/functions/user";
import {ref} from "vue"
import {useRouter} from "vue-router";
import {getPartnerLink} from "@/functions/partnerLink";
import {sendAuthenticatedRequest} from "@/functions/authenticatedRequest";
import {parseCreationOptionsFromJSON} from "@github/webauthn-json/browser-ponyfill";
import {createResponseToJSON} from "@github/webauthn-json/extended";
import {signalAcceptedCredentials} from "@/functions/signalCredentials";
import {readLoginSuccess} from "@/functions/loginRead";

const registerStartApi = process.env.VUE_APP_PASSKEY_REGISTER_START_API
const registerFinishApi = process.env.VUE_APP_PASSKEY_REGISTER_FINISH_API

const advertiserClickIdParams = ['gclid','gbraid','wbraid','dclid','msclkid','fbclid',
	'ttclid','li_fat_id','twclid','rdt_cid','epik','ScCid']

const LoggedIn = () => {
	const router = useRouter()
	const rejectTimeout = ref(null);

	let urlParamsArray
	let urlParamsString

	const redirectUserToTaxesApp = async (data) => {
		await addUrlParametersToData(data)
		const read = readLoginSuccess(data)
		let path = read.redirectUrl
		let method = 'POST'
		let parameters = {
			'tp': 90,
		}

		const form = document.createElement('form');
		form.method = method;
		form.action = path;
		document.body.appendChild(form);

		for (const key in parameters) {
			const formField = document.createElement('input');
			formField.type = 'hidden';
			formField.name = key;
			formField.value = parameters[key];

			form.appendChild(formField);
		}
		if (user.isPasskeyAvailable) {
			await signalAcceptedCredentials(read.AllAcceptedCredentialsOptions)
		}
		/*
		const serverType = process.env.VUE_APP_ENV_NAME
		const isTest = serverType === 'test' || serverType === 'dev'
		if (user.isPasskeyAvailable && PublicKeyCredential.getClientCapabilities && isTest) {
			let timeoutId;
			try {
				let capabilities = await PublicKeyCredential.getClientCapabilities();
				if (capabilities.conditionalCreate && data.passwordSignIn) {
					const request = sendAuthenticatedRequest(registerStartApi, router, {
						credentials: "include"
					});
					let createAbortController = new AbortController();
					const startResponse = await (await request).json();
					const parsedOptions = parseCreationOptionsFromJSON(startResponse);
					let conditionalOptions = {...parsedOptions, mediation: 'conditional'};
					console.time('credentialCreation')
					const timeoutPromise = new Promise((_, reject) => {
						rejectTimeout.value = () => {
							createAbortController.abort("timeout");
							reject(new Error("timeout")); // Force abort request for extensions like 1Password
						};

						timeoutId = setTimeout(() => {
							rejectTimeout.value()
						}, 500); // enough time to create, but not enough to allow 1Password to show
					});
					const credential = await Promise.race([
						navigator.credentials.create(conditionalOptions),
						timeoutPromise
					]);
					console.timeEnd('credentialCreation');
					const response = createResponseToJSON(credential);
					let isFreeFile = (!!sessionStorage.getItem('isFreeFile'));
					await sendAuthenticatedRequest(registerFinishApi, router, {
						method: "POST",
						credentials: "include",
						headers: {
							"Content-Type": "application/json"
						},
						body: JSON.stringify({
							credential: response,
							isFreeFile: isFreeFile,
							isConditional: true,
						})
					});
					form.submit();
					return;
				}
			} catch (error) {
				if (timeoutId)
					clearTimeout(timeoutId);
				console.timeEnd('credentialCreation');
				console.error('Passkey registration error:', error);
			}
		}
		 */

		form.submit();
	}

	const redirectNewUserToTaxesApp = async (data, m) => {
		await addUrlParametersToData(data)
		let path = data.redirectUrl
		let method = 'POST'
		let parameters = {
			'tp': 89,
			'verify_method': m,
		}

		const form = document.createElement('form');
		form.method = method;
		form.action = path;
		document.body.appendChild(form);

		for (const key in parameters) {
			const formField = document.createElement('input');
			formField.type = 'hidden';
			formField.name = key;
			formField.value = parameters[key];
			form.appendChild(formField);
		}

		form.submit();
	}

	const addUrlParametersToData = (data) => {
		if (sessionStorage.getItem('urlParamString')) {
			urlParamsArray = sessionStorage.getItem('urlParamString')
			urlParamsArray = JSON.parse(urlParamsArray)

			// whitelist valid url parameters
			const validParameters = ['PRMPT','NEWTAX','DLX','PROSUPPORT','NEWEXT','AD','FREEFILE','AMENDED','PAIDPREPARER'];
			urlParamsArray = urlParamsArray.filter(param => {
				const [key] = param.split('=');
				return validParameters.includes(key);
			});

			if (urlParamsArray.length > 1 || urlParamsArray[0] !== '/') {
				urlParamsString = '&'
				urlParamsArray.forEach( param => {
					urlParamsString += param + '&'
				})
				urlParamsString = urlParamsString.slice(0, -1)
			}

			if (urlParamsString !== 'undefined') {
				data.redirectUrl = data.redirectUrl + urlParamsString
			}
		}

		if (sessionStorage.getItem('CMP') !== null) {
			data.redirectUrl += '&CMP=' + sessionStorage.getItem('CMP')
		}

		if (sessionStorage.getItem('DX') !== null) {
			data.redirectUrl += '&DX=' + sessionStorage.getItem('DX')
		}

		if (sessionStorage.getItem('goto_page') !== null) {
			data.redirectUrl += '&goto_page=' + sessionStorage.getItem('goto_page')
		}

		if (sessionStorage.getItem('goto_selectedIssue') !== null) {
			data.redirectUrl += '&goto_selectedIssue=' + sessionStorage.getItem('goto_selectedIssue')
		}

		if (sessionStorage.getItem('utm_source') !== null) {
			data.redirectUrl += '&utm_source=' + sessionStorage.getItem('utm_source')
		}

		if (sessionStorage.getItem('utm_campaign') !== null) {
			data.redirectUrl += '&utm_campaign=' + sessionStorage.getItem('utm_campaign')
		}

		if (sessionStorage.getItem('utm_medium') !== null) {
			data.redirectUrl += '&utm_medium=' + sessionStorage.getItem('utm_medium')
		}

		if (sessionStorage.getItem('utm_content') !== null) {
			data.redirectUrl += '&utm_content=' + sessionStorage.getItem('utm_content')
		}

		if (sessionStorage.getItem('utm_term') !== null) {
			data.redirectUrl += '&utm_term=' + sessionStorage.getItem('utm_term')
		}

		if (sessionStorage.getItem('mtm_group') !== null) {
			data.redirectUrl += '&mtm_group=' + sessionStorage.getItem('mtm_group')
		}

		if (sessionStorage.getItem('AID') !== null) {
			data.redirectUrl += '&AID=' + sessionStorage.getItem('AID')
		}

		if (sessionStorage.getItem('PID') !== null) {
			data.redirectUrl += '&PID=' + sessionStorage.getItem('PID')
		}

		if (sessionStorage.getItem('SID') !== null) {
			data.redirectUrl += '&SID=' + sessionStorage.getItem('SID')
		}

		if (sessionStorage.getItem('irclickid') !== null) {
			data.redirectUrl += '&irclickid=' + sessionStorage.getItem('irclickid')
		}

		if (sessionStorage.getItem('sharedid') !== null) {
			data.redirectUrl += '&sharedid=' + sessionStorage.getItem('sharedid')
		}

		if (sessionStorage.getItem('irpid') !== null) {
			data.redirectUrl += '&irpid=' + sessionStorage.getItem('irpid')
		}

		if (sessionStorage.getItem('irgwc') !== null) {
			data.redirectUrl += '&irgwc=' + sessionStorage.getItem('irgwc')
		}

		if (sessionStorage.getItem('share') !== null) {
			data.redirectUrl += '&share=' + sessionStorage.getItem('share')
		}

		if (sessionStorage.getItem('friend') !== null) {
			data.redirectUrl += '&friend=' + sessionStorage.getItem('friend')
		}

		advertiserClickIdParams.forEach(param => {
			const clickId = sessionStorage.getItem(param)
			if (clickId !== null) {
				data.redirectUrl += '&' + param + '=' + encodeURIComponent(clickId)
			}
		})
	}

	const redirectUser = (data) => {
		window.location.href = data.redirectUrl;
	}

	// Dispatcher for a successful /api/login or /api/twoFactor/verify response.
	// Stashes the response in user.loginData for action paths and clears the action on the
	// stashed copy so that replay calls (e.g. handleSuccessfulAuth(user.loginData) from
	// PasskeyUpsell or UpdatePassword on completion) fall through to the redirect branch
	// instead of re-triggering the same action.
	const handleSuccessfulAuth = (data) => {
		const read = readLoginSuccess(data)
		if (read.action === 'CHOOSE_USERNAME') {
			user.loginData = data;
			user.loginData.action = null;
			router.push({name: 'ChooseUsername'});
		}
		else if (read.action === 'UPDATE_PASSWORD') {
			user.loginData = data;
			user.loginData.action = null;
			router.push({name: 'UpdatePassword'});
		}
		else if (read.action === 'PASSKEY_UPSELL' && user.isPasskeyAvailable && user.isPasskeyTurnedOn) {
			user.loginData = data;
			user.loginData.action = null;
			router.push({name: 'PasskeyUpsell'});
		}
		else if (read.redirectUrl && getPartnerLink()) {
			// Link mode: a fresh session now exists — make the explicit link commit
			// (PartnerLinkComplete) before heading into the app. It clears the partner
			// link and replays this call, which then falls through to the redirect.
			user.loginData = data;
			router.push({name: 'PartnerLinkComplete'});
		}
		else if (read.redirectUrl) {
			sessionStorage.removeItem('redirect_uri');
			sessionStorage.removeItem('traceparent');
			if (read.redirectUrl.includes('/taxcontrol')) {
				redirectUserToTaxesApp(data);
			} else {
				redirectUser(data);
			}
		}
	}

	return {
		redirectUserToTaxesApp,
		redirectNewUserToTaxesApp,
		redirectUser,
		handleSuccessfulAuth
	}
}

export default LoggedIn